import React from 'react';
import { Col, Row } from 'antd';
import { SupplierTitle } from 'models/Supplier';
import SupplierCompetitors from 'components/supplier-dynamics/competitors/SupplierCompetitors';
import 'components/supplier-dynamics/SupplierCard.scss';
import { DealDyanmics } from 'components/supplier-dynamics/deal-dynamics/DealDynamics';
import { useRecoilValue } from 'recoil';
import { selectedSupplierDynamicsVendorState } from 'recoil/atoms';

const panelMarginBottom = 24;

/**
 * Represents the props for a component.
 * @interface Props
 */
interface Props {
  profile: string | undefined;
  supplier?: SupplierTitle;
  selectedSupplierCardTab?: string;
  setSelectedSupplierCardTab: (value: ((prevState: string) => string) | string) => void;
  /** When false (e.g. embedded in the deal view), child components don't write deep-link params to the URL. Default true. */
  syncTabToUrl?: boolean;
}

/**
 * Component displaying information about a supplier.
 * @param {Props} props - The properties for the component.
 * @returns {React.ReactElement} - The rendered component.
 */
export const AboutSupplier = (props: Props): React.ReactElement => {
  const { profile, selectedSupplierCardTab, setSelectedSupplierCardTab, syncTabToUrl = true } = props;
  const selectedSupplier = useRecoilValue(selectedSupplierDynamicsVendorState);

  return (
    <Row gutter={24} className="pt-4">
      <Col span={17}>
        {/* <div style={{ marginBottom: panelMarginBottom }} className="panel">
          <div className="panel-header">About {selectedSupplier?.name}</div>
          <div style={{ fontSize: 16 }}>{profile}</div>
        </div> */}

        <div style={{ marginBottom: panelMarginBottom, marginLeft: -12 }}>
          <DealDyanmics />
        </div>
      </Col>
      <Col span={7}>
        <SupplierCompetitors
          selectedSupplierCardTab={selectedSupplierCardTab}
          setSelectedSupplierCardTab={setSelectedSupplierCardTab}
          syncTabToUrl={syncTabToUrl}
        />
      </Col>
    </Row>
  );
};
